import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { isLabSiteTakeoverPayload } from 'lib/lab/dynamicPayload'

export function useSiteTakeoverTheme(): App.LabSiteTakeoverPayload | undefined {
  const enableSiteTakeover = useLabFeatureFlag(LabFeatureFlags.enableSiteTakeover)
  // TODO: Implement preview mode for site takeovers.
  if (!enableSiteTakeover?.enabled || !isLabSiteTakeoverPayload(enableSiteTakeover.value)) {
    return undefined
  }

  return enableSiteTakeover.value
}
